import React from 'react';
import { ContentSidebar } from '../../../components/content-side-bar/ContentSidebar';
import { Advertisement } from '../../../components/content-side-bar/Advertisement';
import { Birthdays } from '../../../components/content-side-bar/Birthdays';
import { PopularNewsItems } from '@components/content-side-bar/PopularNewsItems';
import { ActivityFeed } from '@components/feed/ActivityFeed';
import { PortalPageLayout } from '@layouts/PortalPageLayout';
import { useTranslation } from 'react-i18next';

export const FeedPage: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  const SideBar: JSX.Element = (
    <ContentSidebar>
      <Birthdays />
      <PopularNewsItems />
      <Advertisement />
    </ContentSidebar>
  );

  return (
    <PortalPageLayout
      title={t('activities:overviewPage.title')}
      sidebarContent={SideBar}
      wrapContentInPanel={false}
      hidePageTitle
    >
      <ActivityFeed />
    </PortalPageLayout>
  );
};
